import styled from 'styled-components';

export const IconBar = styled.div`
  color:lightgrey;
  margin-bottom:1rem;
`;